import React from 'react';

import { Badge, Callout } from './shared';

const PsiScore: React.FC = () => (
  <div>
    <h2 className="text-2xl font-bold mb-4">PSI Score</h2>
    <p className="text-sm text-base-content/70 mb-5 leading-relaxed">
      The <strong>Project Stability Index (PSI)</strong> is MFlow&apos;s composite health score for a project, ranging
      from 0 to 100. It weighs three things: how much finished work landed on time (<strong>delivery</strong>, 40%), how
      often completed work gets reopened (<strong>quality</strong>, 30%), and how fast work actually moves through your
      workflow (<strong>flow</strong>, based on cycle time, 30%). It&apos;s shown for Jira projects and MFlow&apos;s own
      Standalone boards. Trello boards get a different set of board-level metrics instead — see{' '}
      <strong>Jira, Trello &amp; Standalone</strong>.
    </p>

    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
      {[
        { range: '80 – 100', label: 'Stable', color: 'badge-success' },
        { range: '60 – 79', label: 'Watch', color: 'badge-info' },
        { range: '40 – 59', label: 'Risk', color: 'badge-warning' },
        { range: '0 – 39', label: 'Critical', color: 'badge-error' },
      ].map((b) => (
        <div key={b.label} className="rounded-lg bg-base-200 shadow-card p-3 text-center">
          <Badge color={b.color}>{b.label}</Badge>
          <div className="text-xs text-base-content/50 mt-1">{b.range}</div>
        </div>
      ))}
    </div>

    <Callout type="info">
      For Jira, PSI is recomputed after every sync (roughly hourly). Standalone has no background sync at all — its PSI
      is calculated fresh every time you open the project, so it&apos;s always current.
    </Callout>

    <div className="h-4" />

    <Callout type="tip">
      A project stuck in <strong>Watch</strong> or below for a while usually indicates systemic issues — growing backlog
      debt, work bouncing between statuses, or a due-date-heavy backlog slipping. Ask the AI assistant for a root-cause
      summary.
    </Callout>
  </div>
);

export default PsiScore;
